import { render, staticRenderFns } from "./DiagramChooseCopper.vue?vue&type=template&id=0cef73ec&"
import script from "./DiagramChooseCopper.vue?vue&type=script&lang=js&"
export * from "./DiagramChooseCopper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports